export const breakpoints = {
  xsmall: `(min-width: 0px)`,
  small: `(min-width: 576px)`,
  medium: `(min-width: 768px)`,
  large: `(min-width: 992px)`,
  xlarge: `(min-width: 1200px)`,
  xxlarge: `(min-width: 1400px)`
};
